import { render } from "./Outpost.vue?vue&type=template&id=49ee8f92&scoped=true"
import script from "./Outpost.vue?vue&type=script&lang=js"
export * from "./Outpost.vue?vue&type=script&lang=js"

import "./Outpost.vue?vue&type=style&index=0&id=49ee8f92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ee8f92"]])

export default __exports__